export const environment = {
  production: true,
  apiUrl: 'https://api.ontariosecuritylicense.ca/v1',
  googleOAuthClientId: '1094998117677-mjumrmm0brhba0620dn041betp33h77t.apps.googleusercontent.com',
  stripePublishableKey: 'pk_live_51LkXeWFOL7gdXuKGQdbciVh3hFce359IKuGMpTLdZF7SDQBMOmcPHu4MCmcanoYVIWKAQL1OLTfNnrANwcDZBpgn00ygkkeJX6',
  googleAPIKey: 'AIzaSyCRaRHWTcibdP2nCwq3lb9h9fCg27meKSk',
  forcePromo: false,
  forceMultiPromo:false,
  checkoutRecoveryEnabled: false,

  // B02 remains fail-closed until the reviewed consent version is configured and activation is approved.
  metaPurchasePixelEnabled: false,
  metaPurchasePixelId: '1163840941256698',
  metaAdvertisingConsentVersion: ''
};
